import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ITransaction, IHolder, IMusic, EMusicStatus, IProducerUser } from "../interfaces";
import CoreComponent from "./CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { arrayToFormData } from "../utils/functions";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import TransactionModal from "../components/TransactionModal";

interface IState {
    models: IProducerUser[],
    limit: number,
    pagination: any,
    query: string,
    ids: number[],
    type: string,
    sort: string,
    isLoading: boolean,
    isOpen: boolean,
    currentPage: number,
}

class RequestsProducer extends CoreComponent<any, IState> {
    state: IState = {
        models: [],
        limit: 30,
        pagination: null,
        query: "",
        ids: [],
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/request/producer?limit=${limit}`;

            if (this.state.sort) {
                url += `&sort=${this.state.sort}`;
            }

            if (this.state.type) {
                url += `&type=${this.state.type}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    models: res.data.models,
                    pagination: res.data.pagination,
                    isLoading: false
                })
            }
        })
    }

    setOrder(sort: string) {
        this.setState({
            type: this.state.sort != sort ? "asc" : (this.state.type == "asc" ? "desc" : "asc"),
            sort
        }, () => {
            this.loadObjects();
        });
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.loadObjects();
        });
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(`${config.api}/request/delete-pu`, arrayToFormData({ id: this.state.ids }));

                if (response.data && response.data.length > 0)
                    this.setState({
                        models: this.state.models.filter((object: IProducerUser) => !response.data.includes(object.id.toString())),
                        ids: []
                    });

                toast("Привязки удалены: " + response.data.length, { type: "success" });
            } else {
                toast("Выберите запрос", { type: "error" });
            }
        }
    }

    async accept(id: number) {
        let res = await Axios.post(`${config.api}/request/change-pu`, arrayToFormData({ id }));

        if (res.data.status == "success") {
            toast("Правообладатель добавлен", { type: "success" });
            this.loadObjects();
        }
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        }, () => {
            this.loadObjects();
        });
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-menu">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>

                    <span className="crm-holders__title">Запросы</span>

                    <div className="crm-requests">
                        <div className="tabs">
                            <div className="tabs-header">
                                <NavLink to="/admin/requests">
                                    <div className="tabs-header__item">
                                        По балансу
                                </div>
                                </NavLink>
                                <NavLink to="/admin/requests/sms">
                                    <div className="tabs-header__item">
                                        По СМС
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/requests/activate">
                                    <div className="tabs-header__item">
                                        По активации
                                </div>
                                </NavLink>
                            {/* <NavLink to="/admin/requests/music">
                                    <div className="tabs-header__item">
                                        Музыка
                                    </div>
                                </NavLink> */}
                                <NavLink to="/admin/requests/composition-change">
                                    <div className="tabs-header__item">
                                        Изменение объектов
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/requests/producer">
                                    <div className="tabs-header__item border-line">
                                        От продюсеров
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/requests/change">
                                    <div className="tabs-header__item">
                                        Изменение данных
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/requests/object">
                                    <div className="tabs-header__item">
                                        Объекты
                                    </div>
                                </NavLink>
                            </div>

                            <div className="tabs-content">
                                <div className="tabs-content__item active js-tab-content">
                                    <div
                                        className="tabs-content-items"
                                        style={{ display: "flex" }}
                                    >
                                        <div className="crm-list" >
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input type="checkbox" onChange={() => {
                                                                if (this.state.ids.length != this.state.models.length) {

                                                                    this.setState({
                                                                        ids: this.state.models.map((holder: IProducerUser) => holder.id)
                                                                    });

                                                                } else {
                                                                    this.setState({
                                                                        ids: []
                                                                    })
                                                                }
                                                            }} checked={this.state.ids.length == this.state.models.length} />
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("producer");
                                                            }}>
                                                                Продюсер
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("user");
                                                            }}>
                                                                Правообладатель
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("type");
                                                            }}>
                                                                Тип
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("date");
                                                            }}>
                                                                Дата
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button">
                                                                Действии
                                                            </a>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!this.state.isLoading && this.state.models.length == 0 && <tr><td colSpan={11}>{t("Ничего не найдено")}</td></tr>}
                                                    {this.state.isLoading && <tr><td colSpan={11}>{t("Загрузка данных")}</td></tr>}
                                                    {this.state.models.map((object: IProducerUser, i: number) => {
                                                        return <tr key={i}>
                                                            <td>
                                                                <input type="checkbox" checked={!!this.state.ids.find((id: number) => id == object.id)} onChange={(e: any) => {
                                                                    if (e.target.checked) {
                                                                        this.setState({
                                                                            ids: [...this.state.ids, object.id]
                                                                        });
                                                                    } else {
                                                                        this.setState({
                                                                            ids: this.state.ids.filter((id: number) => id != object.id)
                                                                        });
                                                                    }
                                                                }} />
                                                            </td>
                                                            <td className="cursor-pointer">{object.producer.full_name}</td>
                                                            <td className="cursor-pointer">{object.user.full_name}</td>
                                                            <td className="cursor-pointer">{object.typeName}</td>
                                                            <td className="cursor-pointer">{object.created_at}</td>
                                                            <td>
                                                                <a role="button" className="text-green" onClick={() => {
                                                                    this.accept(object.id)
                                                                }}>
                                                                    Принять
                                                                </a>
                                                            </td>
                                                        </tr>;
                                                    })}
                                                </tbody>
                                            </table>
                                            <div className="text-center p-3">
                                                {this.state.models.length > 0 && this.state.models.length < (this.state.pagination?.totalCount) && <a role="button" className="spec-color fs-12" onClick={() => {
                                                    this.showMore();
                                                }}>Показать ещё...</a>}
                                            </div>
                                        </div>
                                        <a
                                            className="crm-button"
                                            role="button"
                                            onClick={() => {
                                                this.delete();
                                            }}
                                            style={{
                                                width: "80px",
                                                height: "30px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginLeft: "15px",
                                                marginTop: "17px",
                                            }}
                                        >
                                            Удалить
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(RequestsProducer));
